import { Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useToast } from "@/comn/hooks";
import { useNavigate } from "react-router-dom";
import { APIS, SF_AUTH_MGMT_DTL, SG_AUTH_LANG_LIST, URLS } from "@/tra/tancis/ptli/ptl/auth/services/PtliAuthService";
import { comnUtils } from "@/comn/utils";
import { SG_AUTH_MENU_LIST } from "@/tra/tancis/ptli/ptl/authmenu/services/PtliAuthMenuService";
import { PTLI1015003Q } from "../authmenu/PTLI1015003Q";
import React from "react";
import { PTLI1015004Q } from "@/tra/tancis/ptli/ptl/authmenu/PTLI1015004Q";
import { useTranslation } from "react-i18next";

/*
 * Auth Management Registration
 * !== 권한 관리 등록 ==!
 */
export const PTLI1005002S = () => {
    const {} = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const navigate = useNavigate();
    const toast = useToast();
    const modal = useModal();
    const langCodes = ["KO", "EN", "TZ"];
    const { t } = useTranslation();

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0052" },
        ],
    });

    const form = {
        authDtl: useForm({ defaultSchema: SF_AUTH_MGMT_DTL }),
    };

    const grid = {
        authLangList: useGrid({ defaultSchema: SG_AUTH_LANG_LIST }),
        authMenuList: useGrid({ defaultSchema: SG_AUTH_MENU_LIST }),
    };

    const fetch = {
        createAuthDtl: useFetch({
            api: () =>
                APIS.createAuthDtl({
                    ...form.authDtl.getValues(),
                    authLangList: grid.authLangList.getData(),
                    cnctList: grid.authMenuList.getData(),
                }),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00058" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                handler.onListBtnClick();
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00026" }), // 저장이 실패하였습니다.
        }),
    };

    const render = {
        authMenuList: {
            cell: {
                menuRelaScrnCnt: (arg: any) => {
                    const { rowValues, value } = arg;
                    return (
                        <button
                            className="underline"
                            onClick={() => {
                                modal.openModal({
                                    draggable: true,
                                    size: "sm",
                                    content: (
                                        <PTLI1015004Q
                                            ptlTpCd={form.authDtl.getValues("ptlTpCd")}
                                            menuId={rowValues.menuId}
                                        />
                                    ),
                                });
                            }}
                        >
                            {value}
                        </button>
                    );
                },
            },
        },
    };

    const handler = {
        onGridAddBtnClick: () => {
            const bsopClsfCd = form.authDtl.getValue("bsopClsfCd");
            const ptlTpCd = form.authDtl.getValue("ptlTpCd");
            if (comnUtils.isEmpty(bsopClsfCd)) {
                return modal.openModal({ content: t("msg.ptl.00265", { 0: t("L_BSOP_CLSF_CD") }) }); // // {0} is a required field. !== {{0}}은 필수 입력사항입니다.. ==!
            }
            if (comnUtils.isEmpty(ptlTpCd)) {
                return modal.openModal({ content: t("msg.ptl.00265", { 0: t("L_PTL_TP_CD") }) }); // // {0} is a required field. !== {{0}}은 필수 입력사항입니다.. ==!
            }

            const modalCallback = (list: any[]) => {
                !comnUtils.isEmpty(list) && list.forEach((item: any) => grid.authMenuList.addRow({ ...item }));
                modal.closeModal();
            };

            modal.openModal({
                draggable: true,
                size: "xl",
                content: (
                    <PTLI1015003Q
                        authId={"new"}
                        bsopClsfCd={form.authDtl.getValue("bsopClsfCd")}
                        ptlTpCd={form.authDtl.getValue("ptlTpCd")}
                        callback={modalCallback}
                        authMenuList={grid.authMenuList.getData()}
                    />
                ),
            });
        },
        onGridDelBtnClick: () => {
            if (!grid.authMenuList.isChecked()) {
                modal.openModal({ content: "msg.ptl.00683" }); // Please select a destination to delete. !== 삭제대상을 선택하세요. ==!
                return;
            }
            modal.openModal({
                content: "msg.com.00049",
                onConfirm: () => {
                    grid.authMenuList.deleteRow("checkbox");
                },
            });
        },

        onSubmitBtnClick: () => {
            modal.openModal({
                content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                onConfirm: () => {
                    form.authDtl.handleSubmit(
                        () => {
                            grid.authLangList.clearData();

                            langCodes.forEach((langCd: any) => {
                                const authNm = form.authDtl.getValue(`authNm${langCd}`);
                                const authDesc = form.authDtl.getValue(`authDesc${langCd}`);
                                if (!comnUtils.isEmpty(authNm) || !comnUtils.isEmpty(authDesc)) {
                                    grid.authLangList.addRow({ langCd: langCd, authNm: authNm, authDesc: authDesc });
                                }
                            });

                            fetch.createAuthDtl.fetch();
                        },
                        () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid !== 데이터가 유효하지 않습니다. ==!
                    )();
                },
            });
        },
        onListBtnClick: () => navigate(`${URLS.ptli1005001q}`),
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.authDtl.schema.bsopClsfCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.authDtl.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.authDtl.schema.authNmTZ} />
                            <Group.Control {...form.authDtl.schema.authDescTZ} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.authDtl.schema.authNmEN} />
                            <Group.Control {...form.authDtl.schema.authDescEN} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.authDtl.schema.authNmKO} />
                            <Group.Control {...form.authDtl.schema.authDescKO} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Section hidden={true}>
                        {" "}
                        <Grid {...grid.authLangList.grid} />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Layout>
                            <Layout.Right>
                                <Layout.Button role={"gridAdd"} onClick={handler.onGridAddBtnClick} />
                                <Layout.Button role={"gridDelete"} onClick={handler.onGridDelBtnClick} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                    <Group.Section>
                        <Grid {...grid.authMenuList.grid} render={render.authMenuList} />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSubmitBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
